import { ValidationError } from 'yup'

function getErrorText(errors: ValidationError[], path: string) {
    if (errors?.length === 0) {
        return null
    }

    return errors?.find((error) => error.path === path)?.errors[0] ?? null
}

export default getErrorText
